import SurveyDemographicInformation from './SurveyDemographicInformation';
import React from 'react';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { DemographicsSettingsQuery } from './__generated__/DemographicsSettingsQuery.graphql';

export type Props = {};

export default function DemographicsSettings({}: Props) {
  const data = useLazyLoadQuery<DemographicsSettingsQuery>(
    graphql`
      query DemographicsSettingsQuery {
        ...useSurveyDemographicInformationFragment_demographicProfileUrl
      }
    `,
    {},
  );

  return <SurveyDemographicInformation demographicProfileUrlRef={data} />;
}
